import PropTypes from 'prop-types';

import './styles/panelStyles.css';

const ActionPanel = ({ children, ...rest }) => (
  <div
    className={
      'panel p-4 flex flex-row justify-between items-center action-panel-styles'
    }
    {...rest}
  >
    {children}
  </div>
);

ActionPanel.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ActionPanel;
